import styled from "styled-components";

export const ContentContainer = styled.div`
  /* flex: 1; */
  width: 100%;
  display: flex;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
`;
export const ButtonText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;
  letter-spacing: -0.07px;
  cursor: ${(p) => (p.$click ? "pointer" : "default")};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const DownloadButton = styled.button`
  display: flex;
  height: 32px;
  padding: 0px 10px;

  justify-content: center;
  cursor: pointer;
  align-items: center;
  white-space: nowrap;

  border-radius: 100px;
  border: 0.5px solid #2877d9;
  background: #2877d9;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  letter-spacing: -0.07px;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 0.75;
  }
  &:active {
    scale: 0.975;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  @media (max-width: 768px) {
    gap: 8px;
  }
`;
export const BigRow = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const BigRowMobile = styled.div`
  display: none;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  border-radius: 100px;
  background: #000;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 40px);
  z-index: 10;
  @media (max-width: 768px) {
    display: flex;
  }
`;
export const DeleteButton = styled.button`
  display: flex;
  padding: 0px 10px;
  height: 32px;
  justify-content: center;
  border-radius: 100px;
  border: 1px solid #ff474a;
  background: #112238;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  svg {
    width: 18px;
    height: 18px;
    margin-bottom: 3px;
    path {
      stroke: #ff474a;
    }
  }
`;

export const CollectionButton = styled.button`
  display: flex;
  align-items: center;
  width: fit-content;
  justify-content: center;
  padding: 0px 10px;
  height: 32px;
  gap: 8px;
  background-color: ${({ $selected }) => ($selected ? "#345884" : "#112238")};
  border-radius: 100px;
  border: 1px solid #345884;

  cursor: pointer;
  &:active {
    transform: scale(0.95);
  }

  transition: all 0.3s ease-in-out;
`;
export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding: 0 16px;
  flex: 1;

  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
  @media (max-width: 480px) {
    justify-content: center;
  }
`;

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  flex: 1;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;
    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
